<template>
  <b-card :title="$t('dashboard.customerSatifiedCall')">
    <b-overlay :show="loading" rounded="sm" variant="light">
      <chartjs-component-pie-chart
        ref="pieChart"
        :key="`callRatingChart-${key}`"
        :height="275"
        :data="getChartData"
        :options="hasData ? chartjsData.pieChart.options : emptyChartOptions"
        class="mb-3"
      />

      <div
        v-for="(rating, index) in ratingData"
        :key="rating.rate"
        :class="index < ratingData.length - 1 ? 'mb-1' : ''"
        class="d-flex justify-content-between"
      >
        <div class="d-flex align-items-center">
          <feather-icon icon="StarIcon" size="16" :class="rating.color" />
          <span class="font-weight-bold ml-75">{{
            $tc("dashboard.star", rating.rate, { star: rating.rate })
          }}</span>
        </div>
        <div>
          <span :class="rating.color">{{ rating.percentage }}%</span>
        </div>
      </div>
    </b-overlay>
  </b-card>
</template>

<script>
import { BCard, BOverlay } from "bootstrap-vue";
import ChartjsComponentPieChart from "@/components/charts-components/ChartjsComponentPieChart.vue";
import chartjsDataDefault from "./callRatingChartOptions";

export default {
  components: {
    ChartjsComponentPieChart,
    BCard,
    BOverlay,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      chartjsData: chartjsDataDefault,
      key: 1,
      ratingData: [
        {
          rate: 5,
          color: "text-primary",
          percentage: 0,
        },
        {
          rate: 4,
          color: "text-success",
          percentage: 0,
        },
        {
          rate: 3,
          color: "text-info",
          percentage: 0,
        },
        {
          rate: 2,
          color: "text-warning",
          percentage: 0,
        },
        {
          rate: 1,
          color: "text-danger",
          percentage: 0,
        },
      ],
    };
  },
  methods: {
    mapRatingData(data) {
      const labels = [];
      for (let i = 5; i > 0; i--) {
        labels.push(this.$tc("dashboard.star", i, { star: i }));
      }
      data.forEach((element, index) => {
        this.ratingData[index].percentage = element;
      });
      this.chartjsData.pieChart.data.datasets[0].labels = labels;
      this.chartjsData.pieChart.data.datasets[0].data = [...data];
      this.key++;
    },
  },
  computed: {
    getChartData() {
      const hasData = this.chartjsData.pieChart.data.datasets[0].data.some(value => value > 0);

      if (!hasData) {
        return {
          datasets: [{
            data: [1],
            backgroundColor: ['#f8f9fa'],
            borderWidth: 0,
            labels: [''],
            hoverBackgroundColor: ['#f8f9fa'],
            hoverBorderWidth: 0
          }]
        };
      }

      return this.chartjsData.pieChart.data;
    },
    hasData() {
      return this.chartjsData.pieChart.data.datasets[0].data.some(value => value > 0);
    },
    emptyChartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          enabled: false
        },
        hover: {
          mode: null
        },
        events: []
      };
    }
  },
};
</script>
